import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=1f0fff2e&scoped=true"
import script from "./Relations.vue?vue&type=script&setup=true&lang=js"
export * from "./Relations.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0fff2e",
  null
  
)

export default component.exports